// import { apiUrl as api_url } from "../utils/helpers/enviroment.helpers";
import { fetchWithCredentials, handleErrorsStatus } from "./httpService";

const api_path = "Turnos/";

export const getTurno = async (id) => {
  try {
    const respuesta = await fetchWithCredentials(
      window.__CONFIG__.apiPrincipal + api_path + id,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return await handleErrorsStatus(respuesta);
  } catch (err) {
    console.error("Error", err);
    throw new Error("Ocurrió un error al buscar el turno.");
  }
};

export const getTurnos = async (dni) => {
  try {
    const respuesta = await fetchWithCredentials(
      window.__CONFIG__.apiPrincipal + api_path + 'dni/' + dni,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return await handleErrorsStatus(respuesta);
    // return [
    //   {
    //     id: 123457,
    //     dni: 38005464,
    //     cri: { id: "682", descripcion: "CRI SANTIAGO DEL ESTERO"},
    //     fecha: "25/12/2020",
    //     estado: { id: 1, descripcion: "Activo"},
    //     grupoFamiliar: [
    //        { dni: 39001455, nombreCompleto: "Magallanes, Matías"},
    //        { dni: 30456321, nombreCompleto: "Magallanes, Juan Manuel"},
    //        { dni: 42005439, nombreCompleto: "Flores, Alejandra"}
    //     ]
    //   },
    //   {
    //       id: 123456,
    //       dni: 38005464,
    //       cri: { id: "4", descripcion: "CRI MISIONES"},
    //       fecha: "15/12/2020",
    //       estado: { id: 9, descripcion: "Anulado"},
    //       grupoFamiliar: []
    //   } s
    // ];
  } catch (err) {
    console.error("Error", err);
    throw new Error("Ocurrió un error al buscar los turnos del titular.");
  }
};

export async function postTurno(dni, fechaCalendariolID, grupoFamiliar, invitados, titularIncluido){
  try {
    const respuesta = await fetchWithCredentials(window.__CONFIG__.apiPrincipal + api_path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        titularDNI: dni,
        fechaCalendarioID: fechaCalendariolID,
        familiaresDNI: grupoFamiliar,
        invitados: invitados,
        titularPresente: titularIncluido || false
      }),
    });
    return await handleErrorsStatus(respuesta);
  } catch (err) {
    console.error("error", err);
    throw new Error(err.message);
  }
}

export const delTurno = async (turnoID, dni) => {
  try {
      await fetchWithCredentials(window.__CONFIG__.apiPrincipal + api_path + turnoID + "/" + dni, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        }
      });
      return true;
  } catch (err) {
    console.error("Error", err);
    throw new Error("Ocurrió un error al intentar anular el turno.");
  }
};